<template>
  <LoginOrReg class="reg">
    <Form ref="form" class="form">
      <PhoneInput v-model.trim="username" name="username" />
      <PasswordInput v-model="password" class="mt-4"/>
      <ConfirmPasswordInput v-model="confirmPassword" :password class="mt-4" />
      <PhoneCodeInput v-if="needSms" v-model.trim="phoneCode" :phone="username" class="mt-4" />

      <van-button
        class="!mt-10 primaryBtn"
        @click="onSubmit"
        :disabled="!canSubmit"
      > {{ $t('LoginOrReg.Reg') }}  </van-button>
    </Form>
  </LoginOrReg>
</template>

<script setup lang="ts">
  import LoginOrReg from '@/components/LoginOrReg/index.vue'
  import PhoneInput from '@a/components/FormInput/phoneInput.vue';
  import PasswordInput from '@a/components/FormInput/passwordInput.vue';
  import ConfirmPasswordInput from '@a/components/FormInput/confirmPasswordInput.vue';
  import PhoneCodeInput from '@a/components/FormInput/phoneCodeInput.vue';
  import Form from 'vant/lib/form';

  import { fromActivityId, referralCode, ch, rewardId, activityType, checkIfInPWA, click_id } from '@/env';
  import * as api from '@/api';
  import { encryptPassword  } from '@/utils';
  import { useUserInfo } from '@/store';
  import useTrack from '@/hooks/useTrack.ts';
  import { useI18n } from 'vue-i18n';
  const { t } = useI18n();

  const username = ref('');
  const password = ref('');
  const confirmPassword = ref('');
  const phoneCode = ref('');
  const captchaId = ref('');

  const router = useRouter();

  const validateMap = ref({
    username: 0,
    password: 0,
    confirmPassword: 0,
    // phoneCode: 0,
  })

  provide('validateMap', validateMap)

  const needSms = ref(false);

  const canSubmit = computed(() => Object.values(validateMap.value).every(item => item === 1))

  const generateRandomImagePath = () => `/${(Math.floor(Math.random() * 57) + 1).toString().padStart(2, '0')}.png`;

  const form = useTemplateRef('form')
  watch(password, () => {
    if (confirmPassword.value) {
      // @ts-ignore
      form.value!.validate(['confirmPassword']).catch(e => {})
    }
  })

  const onSubmit = async () => {
    showLoadingToast(t('Common.Loading'));

    const params: any = {
      username: username.value,
      password: encryptPassword(password.value),
      avatar: generateRandomImagePath(),
      channelNo: ch,
      rewardId,
      activityType,
      clickid: click_id,
      pwa: checkIfInPWA()
    };

    if (referralCode && fromActivityId) {
      params.referralCode = referralCode;
      params.activityId = fromActivityId;
    }

    //需要短信验证码注册
    if (needSms.value) {
      if (phoneCode.value) params.captchaVal = phoneCode.value
      if (captchaId.value) params.captchaId = captchaId.value
    }

    const { code, data } = await api.register(params);
    if (code === 1) {
      useUserInfo().login(data.user, data.token);

      const {track2Platform, trackName} = useTrack()
      track2Platform(trackName.CompleteRegistration)

      showToast({
        icon: 'success',
        iconSize: 30,
        message: 'sucesso',
        onClose: () => {
          track2Platform(trackName.ViewContent)
          router.replace(`/home`);
        }
      });
    }
  }
</script>

<style lang="scss" scoped>
  .reg .form{
    @apply bgs-[var(--reg-bg)] pt-[175px] px-4;
  }
</style>
